import _isString from 'lodash/isString';
import _keys from 'lodash/keys';

const getFirstString = (value) => (
  _isString(value) ? value : getFirstString(value[_keys(value)[0]])
);

export default getFirstString;
